import styled from "styled-components";

import { foundationColors } from "@/v1/themes/colors";

export const PageHeader = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;

export const Title = styled.h1`
  color: ${foundationColors["base-deep-purple"]};
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 8px;
`;

export const Description = styled.p`
  margin-bottom: 20px;
  max-width: 720px;
`;
